import { Command } from '@/app/common/base/command'

export class ForgotCommand extends Command {

    public async run(email: string) {
        await this.client.post('/api/auth/forgot-password', { email })
    }

}
